import React, { Fragment } from 'react';
import { IPageTitle } from './interfaces';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';

export const PageTitle: React.FC<IPageTitle> = ({
  title,
  subTitle,
  backLink,
  spaceBelow = true,
}): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const getLink = (baseRoute: string): string => {
    const from = location.state?.from;

    if (from && from.startsWith(baseRoute)) {
      return from;
    }

    return baseRoute;
  };

  return (
    <Fragment>
      <Stack
        direction="row"
        alignItems="start"
        gap="5px"
        sx={{
          mb: spaceBelow ? '1.5em' : undefined,
        }}
      >
        {backLink && (
          <IconButton onClick={() => navigate(getLink(backLink))} size="small">
            <ArrowBackIcon />
          </IconButton>
        )}
        <Box
          sx={{
            mt: '3px',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {title}
          </Typography>
          {subTitle && (
            <Typography
              variant="h2"
              sx={{
                fontSize: '1.1rem',
              }}
            >
              {subTitle}
            </Typography>
          )}
        </Box>
      </Stack>
    </Fragment>
  );
};
